import React, { useState } from "react";
import { DatePicker } from "antd";
import moment from "moment";

const Repeater = ({ inputFields, setInputFields, disabled }) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const handleFormChange = (index, event) => {
    const { name, files, value } = event.target;
    let data = [...inputFields];

    if (files && files.length > 0) {
      const file = files[0];
      data[index][name] = file;
      const ext = file.name.split(".").pop().toLowerCase();
      if (["jpg", "jpeg", "png", "gif", "webp"].includes(ext)) {
        data[index][`${name}_preview`] = URL.createObjectURL(file);
        data[index][`${name}_type`] = "image";
      } else {
        data[index][`${name}_preview`] = null;
        data[index][`${name}_type`] = "doc";
      }
    } else {
      data[index][name] = value;
    }

    setInputFields(data);
  };

  const handleDateChange = (index, name, val) => {
    let data = [...inputFields];
    data[index][name] = val ? val.format("YYYY-MM-DD") : "";
    setInputFields(data);
  };

  const removeFields = (index) => {
    let data = [...inputFields];
    data.splice(index, 1);
    setInputFields(data);
  };

  const removeImage = (index) => {
    let data = [...inputFields];
    data[index].cert_picture = "";
    data[index].cert_picture_preview = null;
    setInputFields(data);
  };

  const handleDownload = (url, name) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = name || "certificate";
    link.click();
  };

  return (
    <>
      {inputFields.map((input, index) => {
        const url =
          input.cert_picture_preview ||
          (input.cert_picture
            ? typeof input.cert_picture === "string"
              ? process.env.REACT_APP_USER_DOCS_PATH + input.cert_picture
              : URL.createObjectURL(input.cert_picture)
            : null);

        const ext = input.cert_picture
          ? typeof input.cert_picture === "string"
            ? input.cert_picture.split(".").pop().toLowerCase()
            : input.cert_picture.name.split(".").pop().toLowerCase()
          : "";

        const fileName =
          input.cert_picture && typeof input.cert_picture === "string"
            ? input.cert_picture.split("/").pop()
            : input.cert_picture?.name || "";

        return (
          <div key={index} style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "14px" }}>
            <div
              onFocus={() => setActiveIndex(index)}
              onBlur={() => setActiveIndex(null)}
              style={{ flex: 1, border: `1px solid ${activeIndex === index ? "#1D1D1D" : "#e0e0e0"}`, borderRadius: "8px", padding: "14px 18px 6px 18px", background: "#fff", transition: "border-color 0.15s" }}
            >
              <div style={{ display: "flex", alignItems: "center", marginBottom: "12px" }}>
                <span style={{ fontWeight: 600, fontSize: "13px", color: "#1D1D1D", display: "flex", alignItems: "center", gap: "7px" }}>
                  <span style={{ display: "inline-block", width: "8px", height: "8px", borderRadius: "50%", background: "#0bc698", flexShrink: 0 }} />
                  Academic Record {index + 1}
                </span>
              </div>

              <div className="row">
                <div className="col-sm-12 col-md-4">
                  <div className="float-input-wrap mb-3">
                    <input
                      type="text"
                      id={`degree_title_${index}`}
                      placeholder=" "
                      disabled={disabled}
                      name="degree_title"
                      value={input.degree_title}
                      onChange={(e) => handleFormChange(index, e)}
                    />
                    <label htmlFor={`degree_title_${index}`}>Degree / Certificate Title</label>
                  </div>
                </div>
                <div className="col-sm-12 col-md-4">
                  <div className={`float-select-wrap mb-3 ${input.end_date ? "has-value" : ""}`}>
                    <label>End Date</label>
                    <DatePicker
                      style={{ width: "100%" }}
                      format="DD-MM-YYYY"
                      placeholder=""
                      value={input.end_date ? moment(input.end_date, "YYYY-MM-DD") : null}
                      onChange={(val) => handleDateChange(index, "end_date", val)}
                      disabled={disabled}
                    />
                  </div>
                </div>
                <div className="col-sm-12 col-md-4">
                  <div className="float-input-wrap mb-3">
                    <input
                      type="text"
                      id={`institue_${index}`}
                      placeholder=" "
                      disabled={disabled}
                      name="institue"
                      value={input.institue}
                      onChange={(e) => handleFormChange(index, e)}
                    />
                    <label htmlFor={`institue_${index}`}>Institute</label>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-12 col-md-4 mb-3">
                  <div className={`float-select-wrap ${fileName ? "has-value" : ""}`}>
                    <label>Certificate / Degree File</label>
                    <div
                      style={{ height: "44px", border: "1.5px solid #d0d0d0", borderRadius: "8px", padding: "0 14px", display: "flex", alignItems: "center", fontSize: "14px", color: "#6c757d", background: disabled ? "#f5f6f8" : "#fff", cursor: disabled ? "not-allowed" : "pointer", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}
                      onClick={() => !disabled && document.getElementById(`file_${index}`).click()}
                    >
                      {fileName || ""}
                    </div>
                    <input id={`file_${index}`} type="file" disabled={disabled} name="cert_picture" onChange={(e) => handleFormChange(index, e)} style={{ display: "none" }} />
                  </div>
                  {url && (
                    <div className="mt-2">
                      <div style={{ display: "inline-flex", alignItems: "center", gap: "6px", background: "#1e2030", borderRadius: "5px", padding: "5px 10px 5px 12px", fontSize: "13px", color: "#0bc698", maxWidth: "100%", fontWeight: 500 }}>
                        <i className="uil-import" style={{ fontSize: "14px", flexShrink: 0, cursor: "pointer" }} onClick={() => handleDownload(url, fileName)} />
                        <span onClick={() => handleDownload(url, fileName)} style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", flex: 1, cursor: "pointer" }}>
                          {fileName}
                        </span>
                        {!disabled && (
                          <span onClick={() => removeImage(index)} style={{ flexShrink: 0, cursor: "pointer", fontSize: "17px", lineHeight: 1, marginLeft: "2px" }}>×</span>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {inputFields.length > 1 && !disabled && (
              <button
                type="button"
                onClick={() => removeFields(index)}
                style={{ background: "#f0f0f0", border: "none", cursor: "pointer", borderRadius: "8px", width: "42px", height: "42px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, color: "#555" }}
              >
                <i className="uil-trash-alt" style={{ fontSize: "18px" }} />
              </button>
            )}
          </div>
        );
      })}
    </>
  );
};

export default Repeater;
